export const convertToPercentage = (
  value: number | string,
  gradingType: string,
): number => {
  const numericValue = Number(value);
  let percentage = 0;

  switch (gradingType) {
    case "Percentage":
      percentage = numericValue > 1 ? numericValue / 100 : numericValue;
      break;

    default:
      percentage = 0;
  }

  return Number(percentage.toFixed(4));
};

export const convertFromPercentage = (
  value: number | string,
  gradingType: string,
): number => {
  const numericValue = Number(value);
  let result = 0;

  switch (gradingType) {
    case "Percentage":
      result =
        numericValue > 0 && numericValue <= 1
          ? numericValue * 100
          : numericValue;
      break;

    default:
      result = 0;
  }

  return Number(result.toFixed(2));
};
